import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listPublicAgents } from '../services/agentApi';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './LandingPage.css';

const AgentsHubPage = () => {
  useDocumentTitle('Agents');
  const [agents, setAgents] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    listPublicAgents()
      .then(setAgents)
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="landing-page">
      <div className="container">
        <h1>Category agents</h1>
        <p>Specialist agents powered by the DarkNews archive.</p>
        {error && <p className="text-danger">{error}</p>}
        <ul className="list-group">
          {agents.map((agent) => (
            <li key={agent.slug} className="list-group-item d-flex justify-content-between">
              <span>
                <strong>{agent.displayName}</strong>
                <span className="text-muted ms-2">({agent.slug})</span>
              </span>
              <Link to={`/agents/${agent.slug}`} className="btn btn-sm btn-primary">
                Chat
              </Link>
            </li>
          ))}
        </ul>
        {!error && agents.length === 0 && (
          <p className="text-muted">No published agents yet.</p>
        )}
      </div>
    </div>
  );
};

export default AgentsHubPage;
